import formBasicMixin from '@phoenix/mixins/formBasicMixin';
import formAddressFieldsMixin from '@phoenix/mixins/formAddressFieldsMixin';

export default {
  mixins: [formBasicMixin, formAddressFieldsMixin],

  props: {
    countries: {
      type: Array,
      required: true,
    },
    showErrorsInToast: {
      type: Boolean,
      default: true,
    },
    shouldResetFormOnSubmit: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      hasBeenSubmitted: false,
      formConfigName: 'custom',
    };
  },

  computed: {
    columnsCount() {
      return this.form.columns.length;
    },

    shouldDisplaySuccessSection() {
      return this.hasBeenSubmitted && this.form.replaceFormOnSuccess;
    },

    shouldDisplayForm() {
      return !this.shouldDisplaySuccessSection;
    },
  },

  methods: {
    shouldDisplayField(field) {
      return (this.fields[field] && !this.fields[field].isAddressField) || this.fieldIsPresent(field);
    },

    onSuccess(response) {
      this.hasBeenSubmitted = true;

      this.$emit('on-success', response);
    },
  },
};
